export default class Loader {
    
    constructor() {
        this.body = document.querySelector('body');
        this.render();
    }

    render() {
        this.logo = document.createElement('span');
        this.logo.className = 'i-logo_kunstwacht loader_logo';
        this.body.appendChild(this.logo);
    }

    onReady(callback) {
        setTimeout(()=> {
            this.logo.className = 'i-logo_kunstwacht loader_logo hide';
            callback();
        }, 500); 
    }

}


// WEBPACK FOOTER //
// ./modules/Loader/index.js